import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import SiNoOptions from '../../../support/catalogs/complementos/cartaporte/SiNoOptions';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';
import EntradaSalidaOptions from '../../../support/catalogs/complementos/cartaporte/EntradaSalidaOptions';

class CartaPorteBaseForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;

    this.state = {
      data: {
        ...data,
      },
      isValid: false,
      validator: new Validator({}, this.rules()),
    };
  }

  componentDidMount() {
    let catalogos = {};

    const claveTransporte = CartaPorteCatalogoManager.get('c_cp_clave_transporte');

    const registroIstmo = CartaPorteCatalogoManager.get('c_cp_registro_istmo');

    catalogos.claveTransporte = this.getCatalogo(claveTransporte);
    catalogos.registroIstmo = this.getCatalogo(registroIstmo);

    this.setState({
      catalogos,
    });
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion,
            value: item.clave,
          };
        }),
        'label'
      );

      return [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(sorted);
    }
  };

  rules(data = {}) {
    let isRegistroIstmo = data?.RegistroISTMO === 'Sí';
    let isTransporteInternacional = data?.TranspInternac === 'Si';

    const pais = [
      'string',
      'min:3',
      'max:3',
      'in:AFG,ALA,ALB,DEU,AND,AGO,AIA,ATA,ATG,SAU,DZA,ARG,ARM,ABW,AUS,AUT,AZE,BHS,BGD,BRB,BHR,BEL,BLZ,BEN,BMU,BLR,MMR,BOL,BIH,BWA,BRA,BRN,BGR,BFA,BDI,BTN,CPV,KHM,CMR,CAN,QAT,BES,TCD,CHL,CHN,CYP,COL,COM,PRK,KOR,CIV,CRI,HRV,CUB,CUW,DNK,DMA,ECU,EGY,SLV,ARE,ERI,SVK,SVN,ESP,USA,EST,ETH,PHL,FIN,FJI,FRA,GAB,GMB,GEO,GHA,GIB,GRD,GRC,GRL,GLP,GUM,GTM,GUF,GGY,GIN,GNB,GNQ,GUY,HTI,HND,HKG,HUN,IND,IDN,IRQ,IRN,IRL,BVT,IMN,CXR,NFK,ISL,CYM,CCK,COK,FRO,SGS,HMD,FLK,MNP,MHL,PCN,SLB,TCA,UMI,VGB,VIR,ISR,ITA,JAM,JPN,JEY,JOR,KAZ,KEN,KGZ,KIR,KWT,LAO,LSO,LVA,LBN,LBR,LBY,LIE,LTU,LUX,MAC,MDG,MYS,MWI,MDV,MLI,MLT,MAR,MTQ,MUS,MRT,MYT,MEX,FSM,MDA,MCO,MNG,MNE,MSR,MOZ,NAM,NRU,NPL,NIC,NER,NGA,NIU,NOR,NCL,NZL,OMN,NLD,PAK,PLW,PSE,PAN,PNG,PRY,PER,PYF,POL,PRT,PRI,GBR,CAF,CZE,MKD,COG,COD,DOM,REU,RWA,ROU,RUS,ESH,WSM,ASM,BLM,KNA,SMR,MAF,SPM,VCT,SHN,LCA,STP,SEN,SRB,SYC,SLE,SGP,SXM,SYR,SOM,LKA,SWZ,ZAF,SDN,SSD,SWE,CHE,SUR,SJM,THA,TWN,TZA,TJK,IOT,ATF,TLS,TGO,TKL,TON,TTO,TUN,TKM,TUR,TUV,UKR,UGA,URY,UZB,VUT,VAT,VEN,VNM,WLF,YEM,DJI,ZMB,ZWE,ZZZ',
    ];

    return {
      IdCCP: [
        'required',
        'string',
        'size:36',
        'regex:/^[C]{3}[a-f0-9A-F]{5}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$/',
      ],
      TranspInternac: isTransporteInternacional ? ['required'] : ['required'],
      EntradaSalidaMerc: isTransporteInternacional ? ['required'] : ['string'],
      PaisOrigenDestino: isTransporteInternacional ? ['required'].concat(pais) : [].concat(pais),
      ViaEntradaSalida: isTransporteInternacional ? ['required'] : ['string'],
      TotalDistRec: ['required', 'numeric'],
      RegistroISTMO: ['string', 'in:Sí'],
      UbicacionPoloOrigen: [isRegistroIstmo ? 'required' : 'string'],
      UbicacionPoloDestino: [isRegistroIstmo ? 'required' : 'string'],
    };
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);
    const isValid = validator.passes();
    const event = {
      name: 'base',
      isValid: isValid,
    };

    this.setState({
      data,
      isValid: isValid,
    });

    this.props.onFormDataChange(
      {
        ...this.props.data,
        ...data,
      },
      event
    );
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  render() {
    const { data = {}, catalogos = {} } = this.state;

    const rules = this.rules(data);

    return (
      <div className="pb-4">
        <div className="section pt-2">
          <Row>
            {/* TODO Habilitar cuando salga existan 2 versiones distintas */}
            {/* <Col sm md={4}>
              <FormControl
                type="select"
                label="Versión"
                name="Version"
                placeholder=""
                help="Versión del complemento"
                rules=""
                value={data.Version}
                options={Version}
                onChange={this.handleOnChange}
              />
            </Col> */}

            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="IdCCP"
                name="IdCCP"
                placeholder=""
                help=""
                casing={'upper'}
                minLength="36"
                maxLength="36"
                rules={rules.IdCCP}
                value={data.IdCCP}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="Transporte Internacional"
                name="TranspInternac"
                placeholder=""
                help=""
                rules={rules.TranspInternac}
                value={data.TranspInternac}
                options={SiNoOptions}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="Entrada/Salida Mercancía"
                name="EntradaSalidaMerc"
                placeholder=""
                help=""
                rules={rules.EntradaSalidaMerc}
                value={data.EntradaSalidaMerc}
                options={EntradaSalidaOptions}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="text"
                label="País Origen/Destino"
                name="PaisOrigenDestino"
                placeholder=""
                help=""
                casing={'upper'}
                minLength="3"
                maxLength="3"
                rules={rules.PaisOrigenDestino}
                value={data.PaisOrigenDestino}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="Vía Entrada/Salida"
                name="ViaEntradaSalida"
                placeholder=""
                help=""
                rules={rules.ViaEntradaSalida}
                value={data.ViaEntradaSalida}
                options={catalogos.claveTransporte}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="number"
                label="Total Distancia Recorrida"
                name="TotalDistRec"
                placeholder=""
                help=""
                minLength="16"
                maxLength="36"
                rules={rules.TotalDistRec}
                value={this.props.data.TotalDistRec ?? data.TotalDistRec}
                onChange={this.handleOnChange}
              />
            </Col>

            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="Registro ISTMO"
                name="RegistroISTMO"
                placeholder=""
                help=""
                minLength="2"
                maxLength="2"
                rules={rules.RegistroISTMO}
                value={data.RegistroISTMO}
                options={RegistroIstmo}
                onChange={this.handleOnChange}
              />
            </Col>
            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="UbicacionPoloOrigen"
                name="UbicacionPoloOrigen"
                placeholder=""
                help=""
                rules={rules.UbicacionPoloOrigen}
                value={data.UbicacionPoloOrigen}
                options={catalogos.registroIstmo}
                onChange={this.handleOnChange}
              />
            </Col>
            <Col
              sm
              md={4}
            >
              <FormControl
                type="select"
                label="UbicacionPoloDestino"
                name="UbicacionPoloDestino"
                placeholder=""
                help=""
                rules={rules.UbicacionPoloDestino}
                value={data.UbicacionPoloDestino}
                options={catalogos.registroIstmo}
                onChange={this.handleOnChange}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const RegistroIstmo = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Sí',
    value: 'Sí',
  },
];

export default CartaPorteBaseForm;
